// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35r3r","left":"styles_left__2SHUX"};